import { createRouter, createWebHistory } from 'vue-router';
import AboutCourse from '@/views/lms/about-course.vue';
import CourseView from '@/views/lms/course-view.vue';
import NotFoundView from '@/views/not-found-view.vue';
import LoginView from '@/views/login-view.vue';
import CompletedView from '@/views/lms/course-completed.vue';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'about',
            props: true,
            meta: { requiresAuth: true, title: 'About' },
            component: AboutCourse,
        },
        {
            path: '/course/:courseId',
            name: 'course',
            props: true,
            meta: { requiresAuth: true, title: 'Course' },
            component: CourseView,
        },
        {
            path: '/loading',
            name: 'loading',
            props: true,
            component: () => import('@/views/loading-view.vue'),
        },
        {
            path: '/complete/:courseId',
            name: 'completed',
            props: true,
            meta: { requiresAuth: true, title: 'Complete' },
            component: CompletedView,
        },
        {
            path: '/login',
            name: 'login',
            meta: { hideNavBar: true },
            component: LoginView,
        },
        {
            path: '/:catchAll(.*)',
            name: 'not-found',
            component: NotFoundView,
        },
    ],
});

export default router;
